import { useRuntimeConfig } from '#imports'
import type { RouteRecordRaw } from 'vue-router'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import hideConsentNotice from '~/middleware/hideConsentNotice'
import { generateWebviewRoutes } from '~/scopes/webviews/generateWebviewRoutes'
import redirectIfWebview from '~/scopes/webviews/middleware/redirectIfWebview'

import { routeHasValidParams } from '../cms/navigation/routeHasValidParams'
import { CMS } from '../cms/routes-names'

import { LEGAL } from './route-names'

export default (): RouteRecordRaw[] => {
  const { market } = useMarketplace()
  const { tracking } = useRuntimeConfig().public

  const isDidomiEnabled =
    tracking.didomi &&
    tracking.didomi.isEnabled &&
    tracking.didomi.enabledCountryCodes.includes(market.countryCode)

  const legalRoutes: RouteRecordRaw[] = [
    {
      path: 'cookies',
      name: LEGAL.COOKIES,
      component: () => import('~/scopes/legal/pages/Cookies.vue'),
      meta: {
        owners: ['bot-squad-content-front'],
        routeExists: !isDidomiEnabled,
      },
    },
    {
      path: 'get-my-visitor-id',
      name: LEGAL.GET_VISITOR_ID,
      component: () => import('~/scopes/legal/pages/VisitorId.vue'),
      meta: {
        owners: ['bot-squad-content-front'],
      },
    },
  ]

  const legalCmsRoutes: RouteRecordRaw[] = [
    {
      path: 'legal/previous/:pageName',
      component: () => import('~/scopes/cms/Landing.vue'),
      meta: {
        owners: ['bot-squad-content-front'],
        middleware: [hideConsentNotice, redirectIfWebview],
        routeExists: routeHasValidParams,
      },
      children: [
        {
          name: CMS.LEGAL_PREVIOUS_VERSION,
          path: '',
          component: () =>
            import('~/scopes/legal/pages/LegalTemplate/LegalTemplate.vue'),
          meta: {
            middleware: [hideConsentNotice, redirectIfWebview],
            noCookieModal: true,
            owners: ['bot-squad-content-front'],
          },
        },
      ],
    },
    {
      path: 'legal/:pageName',
      component: () => import('~/scopes/cms/Landing.vue'),
      children: [
        {
          name: CMS.LEGAL_PAGE,
          path: '',
          component: () =>
            import('~/scopes/legal/pages/LegalTemplate/LegalTemplate.vue'),
          meta: {
            middleware: [hideConsentNotice, redirectIfWebview],
            routeExists: routeHasValidParams,
            noCookieModal: true,
            owners: ['bot-squad-content-front'],
          },
        },
      ],
    },
  ]

  const webviewRoutes = generateWebviewRoutes(legalCmsRoutes)

  return [...legalRoutes, ...legalCmsRoutes, ...webviewRoutes]
}
